exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"style.sass","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f2b083a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["./src/styles/defs/_colors.sass","./src/styles/defs/_fonts.sass","./src/styles/mixins/_mixins.sass"]}!./src/components/Panel/PanelContent/style.sass
// module id = 531
// module chunks = 3